import React from "react"
import styled from "styled-components"

import { BottomMarginText } from "../../styles"

const StyledInput = styled.input`
  width: 6em;
`

interface NumberTextFieldProps {
  /** Title displayed above the text field */
  title: string
  /** The current value of the text field */
  value: number
  /** Is this editable or not */
  editable: boolean
  /** Callback that gets invoked on user input */
  onChange: (value: number) => void
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

/**
 * Controlled input component that displays a title and lets
 * the user input numbers
 */
export const NumberTextField: React.FunctionComponent<NumberTextFieldProps> = ({
  title,
  value,
  editable,
  onChange
}) => {
  return (
    <Container>
      <BottomMarginText>{title}</BottomMarginText>
      <StyledInput
        disabled={!editable}
        // we only want to allow digits
        pattern="\d"
        value={value}
        onChange={({ target: { value: val } }) => {
          const num = Number.parseInt(
            // if given empty string, fallback to zero
            val || "0",
            10
          )
          onChange(num)
        }}
        type="text"
      />
    </Container>
  )
}
